import { render, staticRenderFns } from "./content-registry.vue?vue&type=template&id=a39796cc&scoped=true&"
import script from "./content-registry.ts?vue&type=script&lang=ts&"
export * from "./content-registry.ts?vue&type=script&lang=ts&"
import style0 from "./content-registry.scss?vue&type=style&index=0&id=a39796cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39796cc",
  null
  
)

export default component.exports